import { createStore } from 'vuex';
import axios from 'axios';

const widgetHelper = require('@/scripts/widgetHelper');

export default createStore({
    state: {
        payLaterWidget: {},
        actionURLs: window.vue.actionURLs,
        vueVariables: window.vue.variables || {}
    },
    getters: {
        payLaterWidget(state) {
            return state.payLaterWidget;
        },
        vueVariables(state) {
            return state.vueVariables;
        }
    },
    mutations: {
        setPayLaterWidget(state, data) {
            state.payLaterWidget = data;
        },
        setVueVariables(state, data) {
            state.vueVariables = { ...state.vueVariables, ...data };
        }
    },
    actions: {
        getPayLaterWidget({ commit, state }) {
            const apiString = `${state.actionURLs['Cart-GetPayLaterWidget']}`;
            return axios.get(apiString)
                .then((response) => {
                    if (response.data.error) widgetHelper.createError(response.data.errorMessage || response.data.message);
                    else commit('setPayLaterWidget', response.data);
                })
                .catch((error) => {
                    widgetHelper.createError(error.response.data.errorMessage || error.response.data.message);
                });
        }
    }
});
